import { UnreachableCaseError } from 'main/util/ts'
import { TFunction } from 'react-i18next'
import { i18nKeyPrefix } from '../i18n'
import { ContactSchoolModal } from './gql/__generated__/ContactSchoolModal'
import { RequestInfoModal } from './gql/__generated__/RequestInfoModal'
import { SchoolContainer, SchoolType, Step, StepName } from './types'

const PRE = `${i18nKeyPrefix}-CONTACT-MODAL`

export function initialStep(
  data: ContactSchoolModal & RequestInfoModal,
  schoolType: SchoolType,
): Step {
  let schoolContainer
  const { school, externalSchool } = data

  switch (schoolType) {
    case SchoolType.Internal:
      if (!school) throw new Error('no school')
      schoolContainer = { __type: schoolType, school }
      break

    case SchoolType.External:
      if (!externalSchool) throw new Error('no external school')
      schoolContainer = { __type: schoolType, externalSchool }
      break

    default:
      throw new UnreachableCaseError(schoolType)
  }

  const { user } = data

  return user
    ? { __stepname: StepName.Contact, schoolContainer, user }
    : { __stepname: StepName.SignUp, schoolContainer }
}

export function title(step: Step, t: TFunction) {
  const { schoolContainer } = step

  switch (step.__stepname) {
    case StepName.SignUp:
    case StepName.Login:
      if (schoolContainer.__type === SchoolType.External) return t(`${PRE}-START-EXTERNAL`)
      return t(`${PRE}-START-INTERNAL`)

    case StepName.Contact:
      const { user } = step
      if (!user.firstName) return t(`${PRE}-WELCOME`)
      return t(`${PRE}-WELCOME-WITH-NAME`, { name: user.firstName })

    case StepName.Confirmation:
      if (schoolContainer.__type === SchoolType.External) {
        return t(`${PRE}-CONFIRM-EXTERNAL`)
      }
      const directorFirstName = getDirectorFirstName(step.schoolContainer)
      if (directorFirstName) {
        return t(`${PRE}-CONFIRM-WITH-NAME`, { directorFirstName })
      }
      return `${PRE}-CONFIRM`

    default:
      throw new UnreachableCaseError(step)
  }
}

export function getDirectorFirstName(schoolContainer: SchoolContainer) {
  switch (schoolContainer.__type) {
    case SchoolType.Internal:
      if (!schoolContainer.school.director) throw new Error('no director')
      return schoolContainer.school.director.firstName

    case SchoolType.External:
      return schoolContainer.externalSchool.directorFirstName
  }
}

export function getSchoolName(schoolContainer: SchoolContainer) {
  switch (schoolContainer.__type) {
    case SchoolType.Internal:
      return schoolContainer.school.name

    case SchoolType.External:
      return schoolContainer.externalSchool.name
  }
}
